import React from 'react';
import { array, func } from 'prop-types';
import { contains } from 'ramda';

import cx from 'classnames';
import s from './MedicationsList.css';
import Checkbox from '../../../Checkbox/Checkbox';
import HealthRecordNotes from '../HealthRecordNotes/HealthRecordNotes';

function MedicationsList({ medications, onSelect, onSelectAll, selectedMedications, }) {

  const areAllSelected = medications.length > 0 && medications.length === selectedMedications.length;

  const isChecked = (id) => contains(id, selectedMedications);

  const emptyState =
    <tr>
      <td colSpan={7} className={cx(s.cell, s.center, s.noMeds)}>No medications to display</td>
    </tr>;

  const renderMedicationsTableItems = (medications, onSelect) =>
    medications.map(medication => (
      <tr key={medication.id} id={medication.id} className={s.borderBottom}>
        <td className={cx(s.cell, s.bodyCell, s.bold)}>{medication.title}</td>
        <td className={cx(s.cell, s.bodyCell, s.hideMobile)}>{medication.prescriber}</td>
        <td className={cx(s.cell, s.bodyCell, s.hideMobile)}>{medication.start}</td>
        <td className={cx(s.cell, s.bodyCell, s.hideMobile)}>{medication.end}</td>
        <td className={cx(s.cell)}>{medication.active && <p className={s.activeText}>Yes</p>}</td>
        <td className={cx(s.cell, s.bodyCell)}>
          <HealthRecordNotes
            notes={medication.instructions}
          />
        </td>
        <td className={cx(s.cell, s.bodyCell, s.center)}>
          <Checkbox
            ariaLabel={`Select ${medication.title} for refill`}
            id={`requestRefill__${medication.id}`}
            checked={isChecked(medication.id)}
            onChange={() => onSelect(medication.id)}
          />
        </td>
      </tr>
    ));

  const tableItems = medications.length > 0 ? renderMedicationsTableItems(medications, onSelect) : emptyState;
  // SSPI-118 - yes, added a check for IE. the lowest of lows - it's a the best way to get table-layout:fixed and IE scrolls horizontally.
  const isIE = navigator.userAgent.indexOf("MSIE") !== -1  || !!document.documentMode === true;
  const tableStyle = !isIE ? s.table : s.ieStyleRule;

  return (
    <table className={tableStyle}>
      <thead>
        <tr className={s.borderBottom}>
          <th className={cx(s.cell, s.headerCell)}>Name</th>
          <th className={cx(s.cell, s.headerCell, s.hideMobile)}>Prescriber</th>
          <th className={cx(s.cell, s.headerCell, s.hideMobile)}>Start</th>
          <th className={cx(s.cell, s.headerCell, s.hideMobile)}>End</th>
          <th className={cx(s.cell, s.headerCell)}>Active</th>
          <th className={cx(s.cell, s.headerCell)}>Directions</th>
          <th className={cx(s.cell, s.headerCell, s.center)}>
            <Checkbox
              ariaLabel="Select all medications for refill"
              id="requestRefill__selectAll"
              checked={areAllSelected}
              onChange={onSelectAll}
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {tableItems}
      </tbody>
    </table>
  );
}

MedicationsList.propTypes = {
  medications: array.isRequired,
  onSelectAll: func.isRequired,
  onSelect: func.isRequired,
  selectedMedications: array.isRequired,
};

export default MedicationsList;


// WEBPACK FOOTER //
// ./src/components/Pages/Health/MedicationsList/MedicationsList.js